import { ROLES } from "../api";
import { REGIONS } from "./apiUrls";

const BOTH = [REGIONS.OUS, REGIONS.USA];

const TEMP_US_SUPPORT_BOTH_REGIONS =
  process.env.REACT_APP_TEMP_US_SUPPORT_BOTH_REGIONS === "true";

export const ROLE_ALLOWED_REGIONS = {
  [ROLES.ADMIN]: BOTH,
  [ROLES.VIEW]: BOTH,
  [ROLES.COMPLIANCE]: BOTH,
  [ROLES.PMS]: BOTH,
  [ROLES.SUPPORT]: [REGIONS.OUS],
  [ROLES.US_APPROVAL]: [REGIONS.USA],
  [ROLES.US_MARKETING]: [REGIONS.USA],
  [ROLES.US_SUPPORT]: TEMP_US_SUPPORT_BOTH_REGIONS ? BOTH : [REGIONS.USA],
};

export const getAllowedRegions = (roleName) =>
  ROLE_ALLOWED_REGIONS[roleName] ?? [];
